import { ApiRequest, ApiResponse, HttpMethod } from '@axl/accel-framework/api';
import { StudentCourseProgress } from 'models';

export class CompleteCourseItemTheoryRequest extends ApiRequest {
    public method = HttpMethod.PUT;
    public url: string = `/student-course-item/complete-theory`;
    public body = {
        studentCourseItemProgressId: this.studentCourseItemProgressId
    }

    constructor(public studentCourseItemProgressId: string) {
        super();
    }
}

export class CompleteCourseItemTheoryResponse extends ApiResponse {
    progress: StudentCourseProgress;
    constructor(response: any) {
        super(response);
        this.progress = StudentCourseProgress.fromJson(this.body);
    }
}